const module = {
  firestorePath: 'listings',
  firestoreRefType: 'collection', // or 'doc'
  moduleName: 'listing',
  statePropName: 'data',
  namespaced: true, // automatically added

  sync: {
    defaultValues: {
      noContract: '',
      id: '',
      logoUrl: '',
      thumbnailUrl: '',
      bannerUrl: '',
      name: '',
      titleId: '',
      titleEn: '',
      excerptId: '',
      excerptEn: '',
      descriptionId: '',
      descriptionEn: '',
      category: {
        subcategory: {}
      },
      owner: {},
      saler: {},
      sosmedLinks: {},
      status: 'Active',
      workHour: {},
      email: '',
      address: '',
      phones: [],
      counter: {
        hits: 0,
        likes: 0,
        posts: 0
      },
      isTopList: false,
      dateRegister: null,
      dateRenewal: null,
      isDeleted: false,
      price: 0,
      priceRenewal: 0,
    }
  },

  // this object is your store module (will be added as '/myModule')
  // you can also add state/getters/mutations/actions
  state: {},
  getters: {
    arrayData: state => {
      let data = []

      for (const key in state.data) {
        if (state.data.hasOwnProperty(key)) {
          data.push(state.data[key]);
        }
      }

      return data
    }
  },
  mutations: {},
  actions: {},
}

export default module
